import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Changed from './styles/index.css'
import App from './App/App';  // Changed from './App'
import reportWebVitals from './styles/reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();